import React from 'react';

const DeviceDesktop = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 15.8333H17.5M4.16667 5.83333C4.16667 5.61232 4.25446 5.40036 4.41074 5.24408C4.56702 5.0878 4.77899 5 5 5H15C15.221 5 15.433 5.0878 15.5893 5.24408C15.7455 5.40036 15.8333 5.61232 15.8333 5.83333V12.5C15.8333 12.721 15.7455 12.933 15.5893 13.0893C15.433 13.2455 15.221 13.3333 15 13.3333H5C4.77899 13.3333 4.56702 13.2455 4.41074 13.0893C4.25446 12.933 4.16667 12.721 4.16667 12.5V5.83333Z",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
DeviceDesktop.displayName = "Icons.DeviceDesktop";

export { DeviceDesktop };
//# sourceMappingURL=DeviceDesktop.js.map
